// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const EgressStrategySchema = z.enum(['DIRECT','CONNECTOR','ROTATING_PROXY'] as const);

export type EgressStrategyType = `${z.infer<typeof EgressStrategySchema>}`

export default EgressStrategySchema;
